import { useQuery, useMutation } from '@tanstack/react-query';
import { apiHelper } from '../lib/api';

export function useValidateResetToken(token) {
    return useQuery({
        queryKey: ['password-reset-token', token],
        queryFn: () => apiHelper.getResource('/auth/password/validate-token/', {
            params: { token },
            suppressToast: true,
        }),
        enabled: !!token,
        retry: false,
    });
}

export function useForgotPassword() {
    return useMutation({
        mutationFn: ({ email }) => apiHelper.postResource('/auth/password/forgot/', { email }),
    });
}

export function useResetPasswordConfirm() {
    return useMutation({
        mutationFn: ({ token, new_password, confirm_password }) =>
            apiHelper.postResource('/auth/password/reset-confirm/', {
                token,
                new_password,
                confirm_password,
            }, { suppressToast: true }),
    });
}
